(() => {
  const currentFilter = () => {
    const fromUrl = new URLSearchParams(window.location.search).get('pitb_filter');
    if (fromUrl && fromUrl !== 'all' && fromUrl !== 'pitb-preorder') return fromUrl;

    const active = document.querySelector('[data-pitb-filters] a[data-filter].is-active');
    const key = active && active.getAttribute('data-filter');
    if (key && key !== 'all' && key !== 'pitb-preorder') return key;

    return '';
  };

  const buildSearchHref = (form) => {
    const input = form.querySelector('input[name="q"]');
    const query = input?.value?.trim() || '';

    const action = form.getAttribute('action') || '/search';
    const url = new URL(action, window.location.origin);
    const params = new URLSearchParams();

    form.querySelectorAll('input[name]').forEach((field) => {
      if (field.name === 'q') return;
      if (field.type === 'hidden') {
        params.set(field.name, field.value);
      }
    });

    // Empty box resets the search query but keeps the chosen category filter.
    if (query) {
      params.set('q', query);
    } else {
      params.delete('q');
    }

    const filter = currentFilter();
    if (filter) params.set('pitb_filter', filter);
    else params.delete('pitb_filter');

    const qs = params.toString();
    return `${url.pathname}${qs ? `?${qs}` : ''}`;
  };

  document.querySelectorAll('[data-pitb-search-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const href = buildSearchHref(form);
      event.preventDefault();
      window.location.assign(href);
    });
  });

  document.querySelectorAll('[data-pitb-search-toggle]').forEach((toggle) => {
    const form = toggle.closest('[data-pitb-search-form]');
    const panel = form && form.querySelector('[data-pitb-search-panel]');
    const input = form && form.querySelector('[data-pitb-search-input]');
    if (!form || !panel || !input) return;

    const setExpanded = (open) => {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close search' : 'Search');
    };

    const close = () => setExpanded(false);

    toggle.addEventListener('click', () => {
      if (!panel.hidden) {
        close();
        return;
      }

      setExpanded(true);
      input.focus();
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        form.requestSubmit();
      }
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  });
})();
